import React, { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const LegalPage = ({ pageSlug }) => {
  const [content, setContent] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(`${BACKEND_URL}/api/site-config/legal/${pageSlug}`);
        if (response.ok) {
          const data = await response.json();
          setContent(data);
        } else {
          setError('Page not found');
        }
      } catch (err) {
        setError('Failed to load page');
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchContent();
  }, [pageSlug]);

  if (isLoading) {
    return (
      <div className="min-h-screen pt-24 pb-12 flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen pt-24 pb-12 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">Page Not Found</h1>
          <p className="text-muted-foreground">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-24 pb-12">
      <section className="px-6 md:px-12 lg:px-24">
        <div className="max-w-4xl mx-auto">
          <div className="glass-card rounded-2xl p-8 md:p-12">
            <h1 className="font-outfit text-3xl md:text-4xl font-bold mb-6" data-testid="legal-page-title">
              {content?.title}
            </h1>
            
            {content?.last_updated && (
              <p className="text-sm text-muted-foreground mb-8">
                Last updated: {new Date(content.last_updated).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </p>
            )}
            
            <div 
              className="prose prose-invert max-w-none legal-content"
              dangerouslySetInnerHTML={{ __html: content?.content || '' }}
              data-testid="legal-page-content"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalPage;
